<section class="">
  <div class="container-fluid col-lg-11 mx-auto pb-5 mb-5">
    <div class="py-3"></div>

    <form [formGroup]="newProduct" (submit)="onSubmit()" class="shadow-sm p-2 p-lg-4 bg-white rounded">
      <div class="row g-4">
        <!-- Category Select -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">Select a Category <span class="text-danger">*</span></label>
          <select class="form-select" formControlName="tempCategoryName" (change)="onSelectCategory($event)">
            <option selected disabled value="">Select a Category</option>
            <option *ngFor="let cat of categoryDetails">{{ cat.categoryName }}</option>
          </select>
          <div class="text-danger small mt-1" *ngIf="newProductError.tempCategoryName">{{
            newProductError.tempCategoryName }}</div>
        </div>

        <!-- Product Name -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">Product Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="productName" placeholder="Enter a Product Name" />
          <div class="text-danger small mt-1" *ngIf="newProductError.productName">{{ newProductError.productName }}
          </div>
        </div>

        <!-- MRP -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">MRP <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="mrp" placeholder="Enter MRP" />
          <div class="text-danger small mt-1" *ngIf="newProductError.mrp">{{ newProductError.mrp }}</div>
        </div>

        <!-- GST -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">GST (%) <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="gst" placeholder="Enter GST %" />
          <div class="text-danger small mt-1" *ngIf="newProductError.gst">{{ newProductError.gst }}</div>
        </div>

        <!-- Landing Price -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">Landing Price <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="landingPrice" placeholder="Enter Landing Price" />
          <div class="text-danger small mt-1" *ngIf="newProductError.landingPrice">{{ newProductError.landingPrice }}
          </div>
        </div>

        <!-- SRP -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">SRP <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="srp" placeholder="Enter SRP" />
          <div class="text-danger small mt-1" *ngIf="newProductError.srp">{{ newProductError.srp }}</div>
        </div>

        <!-- Availability -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">Availability <span class="text-danger">*</span></label>
          <select class="form-select" formControlName="availability">
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>

        <!-- Total Quantity -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">Total Quantity <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="totalQuantity"
            placeholder="Enter Total Quantity" />
          <div class="text-danger small mt-1" *ngIf="newProductError.totalQuantity">{{ newProductError.totalQuantity }}
          </div>
        </div>





        <!-- Description -->
        <div class="col-lg-6 col-md-12 col-12">
          <label class="form-label fw-semibold text-muted">Product Description <span
              class="text-danger">*</span></label>
          <div class="border rounded p-2">
            <quill-editor class="quill-editor" formControlName="description"
              (onContentChanged)="onContentChanged($event)" [modules]="editorModules">
            </quill-editor>
          </div>
          <div class="text-danger small mt-1" *ngIf="newProductError.description">{{ newProductError.description }}
          </div>
        </div>

        <!-- Image Upload -->
        <div class="col-lg-3 col-md-6 col-12">
          <label class="form-label fw-semibold text-muted">Upload Image <span class="text-danger">*</span></label>
          <input type="file" class="form-control" formControlName="imageDetails" (change)="onFileSelected($event)"
            accept="image/*" />
          <small class="text-danger d-block mt-2">
            <b>Requirements:</b> Max 2MB, JPG/PNG. <br />
            Min 1 - Max 6 images.
          </small>
        </div>

        <!-- Main Image Preview -->
        <div class="col-lg-3 col-md-6 col-12 text-center" *ngIf="mainImage || mainImageShow">
          <h6 class="fw-bold mb-2">Main Product Image</h6>
          <div class="card shadow-sm rounded mx-auto" *ngIf="!mainImageShow && mainImage">
            <img [src]="mainImage" class="card-img-top img-fluid rounded" alt="Main Image" />
          </div>
          <div class="card shadow-sm rounded mx-auto" *ngIf="mainImageShow">
            <img [src]="endPoint + '/api/product/image-details/get/' + mainImageId"
              class="card-img-top img-fluid rounded" alt="Main Image" />
          </div>
        </div>
      </div>

      <!-- Image List Gallery -->
      <div class="row mt-4">
        <div class="col-12">
          <div class="row g-3">
            <div class="col-lg-2 col-md-3 col-6" *ngFor="let img of imageList">
              <div class="card h-100 shadow-sm" [class.border-primary]="img.isPrimary">
                <img *ngIf="img.imagePath != ''"
                  [src]="endPoint + '/api/product/image-details/get/' + img.imageDetailsId" [alt]="img.imageName"
                  class="card-img-top img-fluid" style="height: 150px; object-fit: cover;" />
                <img *ngIf="img.imagePath == ''" [src]="img.temporaryImagePath" alt="Uploaded Image"
                  class="card-img-top img-fluid" style="height: 150px; object-fit: cover;" />

                <div class="card-body p-2">
                  <button type="button" class="btn btn-sm btn-outline-primary w-100 mb-2"
                    (click)="setMainImage(img.imagePath || img.temporaryImagePath)">
                    Set as Main
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger w-100"
                    (click)="img.imagePath ? removeServerImage(img.imagePath) : removeLocalImage(img.temporaryImagePath)">
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="row mt-4">
        <div class="col-12 text-center">
          <button type="submit" class="btn btn-success px-5 py-2 fw-semibold">
            {{ isUpdate ? 'Update' : 'Save' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</section>